






































































import { Component, Vue } from 'vue-property-decorator'
import Empty from '@/components/Empty/index.vue'
import { listMpUsers, listMpRoles, updateMpUserRole } from '@/api/mpAuth'

@Component({
  name: 'MpUser',
  components: { Empty }
})
export default class extends Vue {
  private loading = false
  private saving = false
  private userList: any[] = []
  private roleOptions: any[] = []
  private dialogVisible = false
  private editForm = {
    openid: '',
    nickname: '',
    roleIds: [] as number[]
  }

  created() {
    this.loadData()
  }

  private formatNickname(row: any) {
    if (!row) return '微信用户'
    const name = String(row.nickname || row.name || '').trim()
    return name || '微信用户'
  }

  private formatOpenid(openid: string): string {
    if (!openid) return ''
    if (openid.length <= 12) return openid
    return openid.slice(0, 6) + '...' + openid.slice(-4)
  }

  private async loadData() {
    this.loading = true
    try {
      const [users, roles] = await Promise.all([listMpUsers(), listMpRoles()])
      this.userList = (users as any[]) || []
      this.roleOptions = (roles as any[]) || []
    } catch (e) {
      // mpRequest 已提示错误
    } finally {
      this.loading = false
    }
  }

  private formatRoleNames(row: any) {
    if (row.roleNames && row.roleNames.length) {
      return row.roleNames.join('、')
    }
    return row.roleName || '-'
  }

  private openEdit(row: any) {
    this.editForm = {
      openid: row.openid,
      nickname: row.nickname || '',
      roleIds: row.roleIds && row.roleIds.length
        ? [...row.roleIds]
        : (row.roleId ? [row.roleId] : [])
    }
    this.dialogVisible = true
  }

  private async saveUser() {
    if (!this.editForm.roleIds.length) {
      this.$message.warning('请至少选择一个角色')
      return
    }
    this.saving = true
    try {
      await updateMpUserRole({
        openid: this.editForm.openid,
        nickname: this.editForm.nickname,
        roleIds: this.editForm.roleIds
      })
      this.$message.success('保存成功')
      this.dialogVisible = false
      this.loadData()
    } catch (e) {
      // mpRequest 已提示错误
    } finally {
      this.saving = false
    }
  }
}
